module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-4 col-md-2"
  }, [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(this.color))]), _vm._v(" "), _c('div', {
    staticClass: "color-palette-set"
  }, [_c('div', {
    class: [this.colorSet[this.color].className, 'disabled', 'color-palette']
  }, [_c('span', [_vm._v("Disabled")])]), _vm._v(" "), _c('div', {
    class: [this.colorSet[this.color].className, 'color-palette']
  }, [_c('span', [_vm._v(_vm._s(this.colorSet[this.color].color))])]), _vm._v(" "), _c('div', {
    class: [_vm.activeMode, 'color-palette']
  }, [_c('span', [_vm._v("Active")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2f4ec5a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VAColorPaletteSet.vue
// module id = 504
// module chunks = 1